// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ContentComponentItemFragmentDoc } from './ContentComponentItem.fragment.generated';
import { ImageLargeFragmentDoc } from '../imageLarge.fragment.generated';
export const ComponentTextOverImageFragmentDoc = gql`
    fragment componentTextOverImage on ComponentTextOverImage {
  content {
    ...contentComponentItem
  }
  image {
    ...imageLarge
  }
}
    ${ContentComponentItemFragmentDoc}
${ImageLargeFragmentDoc}`;